import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'groupBy' })
export class GroupByPipe implements PipeTransform {
  transform(list: any[], byParam: string): any {
    if (!byParam || byParam === '' || !list) {
      return list;
    }
    list.sort((itemA, itemB) => itemA[byParam].localeCompare(itemB[byParam]));
    return list.map((ele, ind, arr) => {
      ele.mitsTable_firstElement =
        ind === 0 || arr[ind - 1][byParam] !== ele[byParam];
      return ele;
    });
  }
}
